const HorizontalLine = () => {
  return <div className="h-[1px] bg-gray-300 my-5"/>
};
export default HorizontalLine;
